module.exports = __webpack_public_path__ + "static/media/insulation_lcs_10y_n.5eb08106.csv";